import capitalizeFirstLetter from "./capitalizeFirstLetter";

export const  formatKeyAllUpper = (str) => {

    let newStr = str.toLowerCase().split(" ")
    newStr[0] = capitalizeFirstLetter(newStr[0]);    
    let result = newStr.join("_"); // nối lại bằng dấu _

  return result
}

